import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { fromTiptapNode } from 'ricos-converters';
import { createRicosFunctionalExtension } from 'wix-rich-content-plugin-commons';

export const breakout = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'breakout',
  reconfigure(config, _extensions, ricosProps) {
    const breakoutRule = ricosProps.breakoutRule;
    return {
      ...config,
      ...(breakoutRule && {
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: new PluginKey('breakout'),
              props: {
                decorations(state) {
                  const decorations: Decoration[] = [];
                  // Breakouts apply only for root nodes, so we use 'forEach' instead of 'descendants'
                  state.doc.forEach((node, pos) => {
                    const breakoutType = breakoutRule({
                      node: fromTiptapNode(node.toJSON()),
                    });
                    decorations.push(
                      Decoration.node(pos, pos + node.nodeSize, { 'data-breakout': breakoutType })
                    );
                  });
                  return DecorationSet.create(state.doc, decorations);
                },
              },
            }),
          ];
        },
      }),
    };
  },
  createExtensionConfig() {
    return {
      name: this.name,
      priority: 3,
    };
  },
});
